module.exports = __webpack_public_path__ + "static/img/A (25).cc7d17d4.png";